import { Anchor } from '../types/Anchor';

type ResolvedPosition = {
  anchorX: Anchor;
  offsetXpx: number;
  offsetYpx: number;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const resolvePosition = (position?: Record<string, any>): ResolvedPosition => {
  const base = position?.base ?? {};

  let activeRules = {
    anchorX: base.anchorX ?? 'right',
    offsetXpx: base.offsetXpx ?? 0,
    offsetYpx: base.offsetYpx ?? 0,
  };

  Object.entries(position ?? {}).forEach(([query, currentRules]) => {
    if (query === 'base') {
      return;
    }

    if (window.matchMedia(query).matches) {
      activeRules = {
        ...activeRules,
        ...currentRules,
      };
    }
  });

  return activeRules;
};
